function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ImportContinueUnlockTemplate = require('./import-continue-unlock.template');
var _require = require('./overlay.shell'),
  applyPublishOverlayShell = _require.applyPublishOverlayShell;
var _require2 = require('../../transaction_io'),
  parseTransactionFile = _require2.parseTransactionFile;
var _require3 = require('./import-dropzone'),
  bindDropzone = _require3.bindDropzone;
function escapeHtml(text) {
  return String(text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/** Minimum spinner visibility — deliberate processing feedback. */
var MIN_LOAD_MS = 1500;
function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

/**
 * Import an in-progress unlock transaction into the existing Unlock workspace.
 * Initialization differs from locking-tx import; the workspace does not.
 */
var ContinueUnlockImportFlow = /*#__PURE__*/function () {
  function ContinueUnlockImportFlow(app, mod, mainUi) {
    var _this = this;
    _classCallCheck(this, ContinueUnlockImportFlow);
    this.app = app;
    this.mod = mod;
    this.mainUi = mainUi;
    this.overlay = new SaitoOverlay(app, mod, true, true, false);
    this.overlay["class"] = 'saito-overlay rs-publish-overlay-shell';
    this.overlay.clickBackdropToClose = true;
    this.overlay.nonBlocking = false;
    this.step = null;
    this.errorMessage = '';
    this.blockedRoot = null;
    this._processing = false;
    this._completed = false;
    this.onEscapeKey = function (event) {
      if (event.key === 'Escape' && _this.step && _this.step !== 'loading') {
        _this.hide();
      }
    };
  }
  return _createClass(ContinueUnlockImportFlow, [{
    key: "open",
    value: function open() {
      this.errorMessage = '';
      this._completed = false;
      this.step = 'idle';
      this.show(ImportContinueUnlockTemplate.idleOverlay());
      this.bindIdleEvents();
    }
  }, {
    key: "show",
    value: function show(html) {
      var _this2 = this;
      document.body.classList.add('rs-publish-modal-open');
      this.blockedRoot = document.querySelector('main.rustscript');
      if (this.blockedRoot) {
        this.blockedRoot.inert = true;
      }
      document.addEventListener('keydown', this.onEscapeKey);
      this.overlay.show(html, function () {
        _this2.onOverlayClosed();
      });
      this.applyOverlayLayout();
    }
  }, {
    key: "hide",
    value: function hide() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$completed = _ref.completed,
        completed = _ref$completed === void 0 ? false : _ref$completed;
      if (completed) {
        this._completed = true;
      }
      if (this.step) {
        this.overlay.close();
      }
    }
  }, {
    key: "onOverlayClosed",
    value: function onOverlayClosed() {
      var returnToImportMenu = this.step != null && !this._completed;
      document.body.classList.remove('rs-publish-modal-open');
      document.removeEventListener('keydown', this.onEscapeKey);
      if (this.blockedRoot) {
        this.blockedRoot.inert = false;
        this.blockedRoot = null;
      }
      this.step = null;
      this._processing = false;
      this._completed = false;
      if (returnToImportMenu) {
        var _this$mainUi;
        (_this$mainUi = this.mainUi) === null || _this$mainUi === void 0 || (_this$mainUi = _this$mainUi.welcomeOverlay) === null || _this$mainUi === void 0 || _this$mainUi.render('import-choice');
      }
    }
  }, {
    key: "applyOverlayLayout",
    value: function applyOverlayLayout() {
      applyPublishOverlayShell(this.overlay);
    }
  }, {
    key: "bindIdleEvents",
    value: function bindIdleEvents() {
      var _this3 = this;
      var root = document.querySelector('.rs-import-continue-unlock-overlay:not(.rs-import-loading)');
      if (!root) {
        return;
      }
      bindDropzone(root, {
        onFile: function onFile(file) {
          return _this3.readAndProcessFile(file);
        }
      });
    }
  }, {
    key: "readAndProcessFile",
    value: function readAndProcessFile(file) {
      var _this4 = this;
      if (this._processing) {
        return;
      }
      this._processing = true;
      var reader = new FileReader();
      reader.addEventListener('error', function () {
        _this4._processing = false;
        _this4.errorMessage = 'Could not read the selected file.';
        _this4.step = 'idle';
        _this4.show(ImportContinueUnlockTemplate.idleOverlay({
          error: escapeHtml(_this4.errorMessage)
        }));
        _this4.bindIdleEvents();
      });
      reader.addEventListener('load', function (event) {
        var _event$target;
        var text = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.result;
        _this4.processFileText(text);
      });
      reader.readAsText(file);
    }
  }, {
    key: "processFileText",
    value: function () {
      var _processFileText = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(text) {
        var error, tx, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.step = 'loading';
              this.show(ImportContinueUnlockTemplate.loadingOverlay());
              error = null;
              _context.p = 1;
              tx = parseTransactionFile(this.app, text);
              _context.n = 2;
              return this.mod.loadUnlockContinuation(tx);
            case 2:
              _context.n = 3;
              return delay(MIN_LOAD_MS);
            case 3:
              this.hide({
                completed: true
              });
              _context.n = 6;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              error = (_t === null || _t === void 0 ? void 0 : _t.message) || 'Could not load unlock transaction.';
              _context.n = 5;
              return delay(MIN_LOAD_MS);
            case 5:
              this._processing = false;
              this.errorMessage = error;
              this.step = 'idle';
              this.show(ImportContinueUnlockTemplate.idleOverlay({
                error: escapeHtml(this.errorMessage)
              }));
              this.bindIdleEvents();
            case 6:
              _context.p = 6;
              if (this.step !== 'idle') {
                this._processing = false;
              }
              return _context.f(6);
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4, 6, 7]]);
      }));
      function processFileText(_x) {
        return _processFileText.apply(this, arguments);
      }
      return processFileText;
    }()
  }]);
}();
module.exports = ContinueUnlockImportFlow;